import { render } from "./McustomerCreate.vue?vue&type=template&id=490fafc8&scoped=true"
import script from "./McustomerCreate.vue?vue&type=script&lang=js"
export * from "./McustomerCreate.vue?vue&type=script&lang=js"

import "./McustomerCreate.vue?vue&type=style&index=0&id=490fafc8&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-490fafc8"]])

export default __exports__